import regist from './compos/regist.vue'


// WEBPACK FOOTER //
// ./src/views/sy/compos.js